import { render, staticRenderFns } from "./RecentFeed.vue?vue&type=template&id=3af27843&scoped=true&"
import script from "./RecentFeed.vue?vue&type=script&lang=ts&"
export * from "./RecentFeed.vue?vue&type=script&lang=ts&"
import style0 from "./RecentFeed.vue?vue&type=style&index=0&id=3af27843&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af27843",
  null
  
)

export default component.exports